import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-reporting-client',
  templateUrl: './detail-reporting-client.component.html',
  styleUrls: ['./detail-reporting-client.component.css']
})
export class DetailReportingClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
